/**
 * Standard API response envelope returned by Reimagine backend controllers.
 */
export interface ApiEnvelope<T> {
  data?: T;
  succeeded?: boolean;
  code?: number;
  message?: string;
}

export function assertApiSuccess<T>(
  envelope: ApiEnvelope<T> | undefined,
  options?: { emptyOnNotFound?: boolean }
): T {
  const failed =
    envelope?.succeeded === false ||
    (typeof envelope?.code === 'number' && envelope.code >= 400);

  if (failed) {
    const message = envelope?.message || 'Request failed';

    if (
      options?.emptyOnNotFound &&
      message.toLowerCase().includes('no data found')
    ) {
      return [] as T;
    }

    throw new Error(message);
  }

  return envelope?.data as T;
}

export function getApiErrorMessage(error: unknown): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof (error as { response?: { data?: unknown } }).response?.data === 'object'
  ) {
    const data = (error as { response: { data: Record<string, unknown> } }).response
      .data;

    if (typeof data?.message === 'string' && data.message) {
      return data.message;
    }

    if (data?.errors && typeof data.errors === 'object') {
      const first = Object.values(data.errors as Record<string, string[]>)[0];
      if (Array.isArray(first) && first[0]) {
        return first[0];
      }
    }

    if (typeof data?.title === 'string' && data.title) {
      return data.title;
    }
  }

  return error instanceof Error ? error.message : 'Request failed';
}
